import * as React from "react";

import { useTranslations } from "@/i18n";
import { startTour } from "../lib/start-tour";
import { MAIN_TOUR_ID } from "../tours/registry";
import { useOnboardingMutations } from "../services/onboarding-query";
import type { TourId } from "../tours/types";

/**
 * Returns a `restart(tourId?)` callback for a visible entry point (e.g. the user menu). It clears the tour's
 * terminal state server-side, then runs it immediately. Steps whose targets aren't present on the current
 * page are skipped gracefully, so it works from anywhere (best on the dashboard).
 */
export function useRestartTour() {
  const t = useTranslations("onboarding");
  const { completeTour, skipTour, restartTour } = useOnboardingMutations();

  return React.useCallback(
    async (tourId: TourId = MAIN_TOUR_ID) => {
      await restartTour(tourId);
      startTour(tourId, t, {
        onComplete: () => completeTour(tourId),
        onSkip: () => skipTour(tourId)
      });
    },
    [t, completeTour, skipTour, restartTour]
  );
}
